import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class YeehroCalendlyAvailabilityService {
  private API_URL = '/api/yeehro-calendly-availability/';
  private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  // Short list (US & Canada only) — default for scheduling/availability dropdowns
  timezoneOptions = [
    { value: 'America/New_York', label: 'Eastern Time - US & Canada' },
    { value: 'America/Chicago', label: 'Central Time - US & Canada' },
    { value: 'America/Denver', label: 'Mountain Time - US & Canada' },
    { value: 'America/Los_Angeles', label: 'Pacific Time - US & Canada' },
    { value: 'America/Anchorage', label: 'Alaska Time' },
    { value: 'America/Phoenix', label: 'Arizona, Yukon Time' },
    { value: 'America/St_Johns', label: 'Newfoundland Time' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time' }
  ];

  // Grouped full list — used by booking calendar timezone picker
  timezoneGroups = [
    {
      region: 'US/CANADA',
      zones: [
        { value: 'America/Los_Angeles', label: 'Pacific Time - US & Canada' },
        { value: 'America/Denver', label: 'Mountain Time - US & Canada' },
        { value: 'America/Chicago', label: 'Central Time - US & Canada' },
        { value: 'America/New_York', label: 'Eastern Time - US & Canada' },
        { value: 'America/Anchorage', label: 'Alaska Time' },
        { value: 'America/Phoenix', label: 'Arizona, Yukon Time' },
        { value: 'America/St_Johns', label: 'Newfoundland Time' },
        { value: 'Pacific/Honolulu', label: 'Hawaii Time' }
      ]
    },
    {
      region: 'AMERICA',
      zones: [
        { value: 'America/Adak', label: 'America/Adak' },
        { value: 'America/Argentina/Buenos_Aires', label: 'Buenos Aires Time' },
        { value: 'America/Asuncion', label: 'Asuncion Time' },
        { value: 'America/Bogota', label: 'Bogota, Jamaica, Lima Time' },
        { value: 'America/Campo_Grande', label: 'America/Campo Grande' },
        { value: 'America/Caracas', label: 'Caracas Time' },
        { value: 'America/Godthab', label: 'America/Godthab' },
        { value: 'America/Halifax', label: 'Atlantic Time' },
        { value: 'America/Guatemala', label: 'Saskatchewan, Guatemala, Costa Rica Time' },
        { value: 'America/Havana', label: 'America/Havana' },
        { value: 'America/Mazatlan', label: 'America/Mazatlan' },
        { value: 'America/Mexico_City', label: 'Mexico City Time' },
        { value: 'America/Montevideo', label: 'Montevideo Time' },
        { value: 'America/Miquelon', label: 'America/Miquelon' },
        { value: 'America/Noronha', label: 'America/Noronha' },
        { value: 'America/Santiago', label: 'Santiago Time' },
        { value: 'America/Santa_Isabel', label: 'America/Santa Isabel' },
        { value: 'Atlantic/Bermuda', label: 'Atlantic Standard Time' },
        { value: 'America/Sao_Paulo', label: 'Brasilia Time' }
      ]
    },
    {
      region: 'AFRICA',
      zones: [
        { value: 'Africa/Cairo', label: 'Africa/Cairo' },
        { value: 'Africa/Johannesburg', label: 'Central Africa Time' },
        { value: 'Africa/Lagos', label: 'West Africa Time' },
        { value: 'Africa/Windhoek', label: 'Africa/Windhoek' }
      ]
    },
    {
      region: 'ASIA',
      zones: [
        { value: 'Asia/Amman', label: 'Jordan Time' },
        { value: 'Asia/Baghdad', label: 'Baghdad, East Africa Time' },
        { value: 'Asia/Baku', label: 'Asia/Baku' },
        { value: 'Asia/Beirut', label: 'Lebanon Time' },
        { value: 'Asia/Damascus', label: 'Syria Time' },
        { value: 'Asia/Dhaka', label: 'Asia/Dhaka' },
        { value: 'Asia/Dubai', label: 'Dubai Time' },
        { value: 'Asia/Gaza', label: 'Asia/Gaza' },
        { value: 'Asia/Irkutsk', label: 'Asia/Irkutsk' },
        { value: 'Asia/Bangkok', label: 'Indochina Time' },
        { value: 'Asia/Jerusalem', label: 'Israel Time' },
        { value: 'Asia/Kabul', label: 'Kabul Time' },
        { value: 'Pacific/Majuro', label: 'Pacific/Majuro' },
        { value: 'Asia/Karachi', label: 'Pakistan, Maldives Time' },
        { value: 'Asia/Kathmandu', label: 'Kathmandu Time' },
        { value: 'Asia/Kolkata', label: 'India, Sri Lanka Time' },
        { value: 'Asia/Krasnoyarsk', label: 'Krasnoyarsk Time' },
        { value: 'Asia/Omsk', label: 'Asia/Omsk' },
        { value: 'Asia/Rangoon', label: 'Asia/Rangoon' },
        { value: 'Asia/Shanghai', label: 'China, Singapore, Perth' },
        { value: 'Asia/Tehran', label: 'Tehran Time' },
        { value: 'Asia/Tokyo', label: 'Japan, Korea Time' },
        { value: 'Asia/Vladivostok', label: 'Asia/Vladivostok' },
        { value: 'Asia/Yakutsk', label: 'Asia/Yakutsk' },
        { value: 'Asia/Yekaterinburg', label: 'Yekaterinburg Time' },
        { value: 'Asia/Yerevan', label: 'Asia/Yerevan' }
      ]
    },
    {
      region: 'ATLANTIC',
      zones: [
        { value: 'Atlantic/Azores', label: 'Azores Time' },
        { value: 'Atlantic/Cape_Verde', label: 'Cape Verde Time' }
      ]
    },
    {
      region: 'AUSTRALIA',
      zones: [
        { value: 'Australia/Adelaide', label: 'Adelaide Time' },
        { value: 'Australia/Brisbane', label: 'Brisbane Time' },
        { value: 'Australia/Darwin', label: 'Australia/Darwin' },
        { value: 'Australia/Eucla', label: 'Australia/Eucla' },
        { value: 'Australia/Lord_Howe', label: 'Australia/Lord Howe' },
        { value: 'Australia/Perth', label: 'Australia/Perth' },
        { value: 'Australia/Sydney', label: 'Sydney, Melbourne Time' }
      ]
    },
    {
      region: 'UTC',
      zones: [
        { value: 'UTC', label: 'UTC Time' }
      ]
    },
    {
      region: 'EUROPE',
      zones: [
        { value: 'Europe/Berlin', label: 'Central European Time' },
        { value: 'Europe/Athens', label: 'Eastern European Time' },
        { value: 'Europe/London', label: 'UK, Ireland, Lisbon Time' },
        { value: 'Europe/Minsk', label: 'Minsk Time' },
        { value: 'Europe/Moscow', label: 'Moscow Time' },
        { value: 'Europe/Istanbul', label: 'Turkey Time' }
      ]
    },
    {
      region: 'PACIFIC',
      zones: [
        { value: 'Pacific/Apia', label: 'Pacific/Apia' },
        { value: 'Pacific/Auckland', label: 'Auckland Time' },
        { value: 'Pacific/Chatham', label: 'Pacific/Chatham' },
        { value: 'Pacific/Easter', label: 'Pacific/Easter' },
        { value: 'Pacific/Fiji', label: 'Pacific/Fiji' },
        { value: 'Pacific/Gambier', label: 'Pacific/Gambier' },
        { value: 'Pacific/Kiritimati', label: 'Pacific/Kiritimati' },
        { value: 'Pacific/Marquesas', label: 'Pacific/Marquesas' },
        { value: 'Pacific/Norfolk', label: 'Pacific/Norfolk' },
        { value: 'Pacific/Noumea', label: 'Pacific/Noumea' },
        { value: 'Pacific/Pago_Pago', label: 'Pacific/Pago Pago' },
        { value: 'Pacific/Pitcairn', label: 'Pacific/Pitcairn' },
        { value: 'Pacific/Tarawa', label: 'Pacific/Tarawa' },
        { value: 'Pacific/Tongatapu', label: 'Pacific/Tongatapu' }
      ]
    }
  ];

  constructor(private httpClient: HttpClient) {}


  getAll(): Observable<any[]> {
    return this.httpClient.get<any[]>(this.API_URL);
  }


  getById(id: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + id);
  }


  getOrCreateForUser(userId: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + 'user/' + userId);
  }


  getAllForUser(userId: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + 'user/' + userId + '/all');
  }


  findForUser(userId: string): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + 'user/' + userId + '/find');
  }


  // Active non-Provider users who have at least one availability record.
  // Used by the reassign dialog so admins only see recruiters whose calendar
  // can actually render slots. Returns { users: [...] }.
  getHostsWithAvailability(): Observable<any> {
    return this.httpClient.get<any>(this.API_URL + 'hosts-with-availability');
  }


  getEventsBySchedule(scheduleId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(this.API_URL + scheduleId + '/events');
  }


  assignEvents(scheduleId: string, eventIds: string[]): Observable<any[]> {
    return this.httpClient.post<any[]>(this.API_URL + 'assign-events', JSON.stringify({ scheduleId, eventIds }), this.headerOptions);
  }


  create(availability: any): Observable<any> {
    return this.httpClient.post<any>(this.API_URL, JSON.stringify(availability), this.headerOptions);
  }


  update(availability: any): Observable<any> {
    return this.httpClient.put<any>(this.API_URL + availability._id, JSON.stringify(availability), this.headerOptions);
  }


  delete(id: string): Observable<any> {
    return this.httpClient.delete<any>(this.API_URL + id);
  }


  search(searchTerms: any): Observable<any[]> {
    return this.httpClient.post<any[]>(this.API_URL + 'search', JSON.stringify(searchTerms), this.headerOptions);
  }


  // ── Shared utilities ──────────────────────────────────


  /**
   * Get the friendly label for a timezone value. Used by the pipe as well.
   * Falls back to the raw value with underscores replaced if not found in any list.
   */
  getTimezoneLabel(value: string): string {
    if (!value) return '';
    // Check short list first (covers common US timezones)
    const shortMatch = this.timezoneOptions.find((tz: any) => tz?.value === value);
    if (shortMatch) return shortMatch.label;
    // Check grouped full list
    for (const group of this.timezoneGroups) {
      const match = group.zones.find((tz: any) => tz?.value === value);
      if (match) return match.label;
    }
    return value.replace(/_/g, ' ');
  }


  buildTimeOptions(): string[] {
    const options: string[] = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 30) {
        options.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
      }
    }
    return options;
  }


  formatTime(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':').map(Number);
    const period = hours >= 12 ? 'pm' : 'am';
    const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    return `${displayHour}:${minutes.toString().padStart(2, '0')}${period}`;
  }
}